import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export const GetFavouriteAddressesAsync = async (
    token: string,
    t: (key: string) => string
  ): Promise<any> => {
    const baseUrl = getApiBaseUrl();
    const apiUrl = `${baseUrl}/api/AddressFavourites/GetFavouriteAddressesAsync`;
  
    if (!navigator.onLine) {
      toast.error(t("internetConnection"), { toastId: "offline-error" });
      return null;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        throw new Error(`Failed to get favourite addresses: ${response.statusText}`);
      }
  
      return response.json();
    } catch (error) {
      // console.error('Error in GetFavouriteAddressesAsync:', error);
      throw error;
    }
  };
  